import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsLazyRouterModule } from '../route.module';

import { NowPlayingVimeoComponent } from './now-playing-vimeo.component';
import { PlayerVimeoComponent } from './player.vimeo.component';
import { PlaylistVimeoComponent } from './playlist.vimeo.component';
import { TextPlaylistVimeoComponent } from './text-playlist.vimeo.component';
import { VimeoComponent } from './vimeo.component';
import { TranslationIdMap } from './vimeo.i18n';
import { VimeoRoutes } from './vimeo.route';
import { VimeoService } from './vimeo.service';

@NgModule({
    imports: [
        CommonModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(VimeoRoutes),
    ],
    declarations: [
        PlayerVimeoComponent,
        NowPlayingVimeoComponent,
        PlaylistVimeoComponent,
        TextPlaylistVimeoComponent,
        VimeoComponent,
    ],
})
export class CmpsVimeoModule {
    static forRoot(): ModuleWithProviders<CmpsVimeoModule> {
        return {
            ngModule: CmpsVimeoModule,
            providers: [VimeoService],
        };
    }
}
